import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { GenericRepository } from "../generic-repository/GenericRepository";
import { environment } from "../../../environments/environment";
import { CustomerSubscriptions } from "src/app/models/CustomerSubscriptions/customer-subscriptions.model";
import { ResponseModel } from "src/app/models/SharedModels/response.model";
import { ICustomerSubscriptionRepository } from "./ICustomerSubscriptionRepo";

@Injectable({
  providedIn: 'root'
})
export class CustomerSubscriptionRepository
  extends GenericRepository<CustomerSubscriptions>
  implements ICustomerSubscriptionRepository {

  url: string = environment.urlAddress;

  constructor(protected _http: HttpClient) {
    super(_http, 'api/CustomerSubscription', environment.urlAddress);
  }

  GetAll(
  currentPage: number,
  recordsPerPage: number,
  filterText: string
): Observable<any> {

  if (!filterText || filterText === "") {
    filterText = "|";
  }
  filterText = encodeURIComponent(filterText);
  return this.Get(
    `/SelectAll/${currentPage}/${recordsPerPage}/${filterText}`
  ).pipe(
    map(this.extractData),
    catchError(this.handleError)
  );
}


  // Save Record
  SaveRec(item: CustomerSubscriptions): Observable<ResponseModel> {
  return this.PostData('', item).pipe( 
    map(this.extractData),
    catchError(this.handleError)
  );
}

  // Navigation (First, Next, Previous, Last)
  LoadNavRec(
    navType: number,
    currentIndex: number
  ): Observable<ResponseModel> {

    return this.GetById(
      `/Select/${navType}/${currentIndex}`
    ).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }

  // Load single record by ID
LoadRec(id: number): Observable<ResponseModel> {
  return this.GetById(`/Select/${id}`).pipe(
    map(this.extractData),
    catchError(this.handleError)
  );
}


  // Delete Record
  DeleteRec(id: number): Observable<ResponseModel> {
    return this.Delete(`/Delete/${id}`).pipe(
      map(this.extractData),
      catchError(this.handleError)
    );
  }
  // Extra (Customer Codes)
  SelectAllCustomerSubscriptionCodes(): Observable<any> {
    return this._http
      .get(`${this.url}/api/buyer/GetAllCustomerSubscriptionCodes`)
      .pipe(
        map(this.extractData),
        catchError(this.handleError)
      );
  }
}
